import styled from "styled-components"
import { background } from '../../assets'

export const Container = styled.div`
    font-size: 1.5rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(0, -50%);
    min-width: 35vw;
    max-width: 90vw;
    display: grid;
    column-gap: 1rem;
    row-gap: 2rem;
    background-color: var(--white);
    padding: 5rem;
    border-radius: 1.5rem;
    @media screen and (max-width: 640px) {
        top: 75%;
        left: 40%;
        //float: center;
    }
`

export const Header = styled.h2`
    font-size: 3.5rem;
`

const formControl = `
    background-color: var(--black) !important;
    color: var(--white) !important;
    border-radius: 0.5rem !important;
    border: none !important;
`

export const Form = styled.form`
    display: grid;
    column-gap: 1rem;
    row-gap: 1.5rem;

    input {
        ${formControl}
    }
    i {
        color: var(--white) !important;
    }
`

export const Label = styled.label`
    display: block;
    margin-bottom: -1rem;
`

export const Button = styled.button`
    width: 50%;
    transform: translate(50%);
    font-size: 1.5rem;
    padding: 1rem;
    margin-top: 4rem;
    ${formControl}
`

export const Error = styled.div`
    padding: 0.5rem;
    color: var(--white);
    background-color: var(--red);
    border-radius: 0.25rem;
    margin-top: -0.75rem;
`

export const Title = styled.div`
    position: absolute;
    background-color: black;
    opacity: 0.9;
    color: var(--white);
    width: 80%;
    height: 30rem;
    left: 10%;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 2rem;
    img {
        position: absolute;
        margin-top: 12rem;
        margin-left: 6%;
        width: 5rem;
    }
    p {
        font-size: 7rem;
        vertical-align: middle;
        height: 100%;
        margin-top: 9.5rem;
        margin-left: 8%;
    }
    @media screen and (max-width: 640px) {
        width: 70%;
        p {
            font-size: 5rem;
        }
    }
`

export const Background = styled.div`
    background-image: url(${background});
    height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`
